<script lang="ts" setup>
import FastAudio from "@/front/components/FastAudio.vue";
// import AudioElement from '@/front/components/AudioElement.vue';
import { AudioStore } from "@/front/stores/audio_store.js";
const audioStore = AudioStore();
const emit = defineEmits([
  "play",
  "pause",
  "seek",
  "ended",
  "timeupdate",
  "error",
]);

const props = defineProps({
  volume: {
    type: Number,
    default: 1,
  },
});
</script>

<template>
  <div class="w-full">
    <FastAudio
      v-if="audioStore.src"
      :volume="props.volume"
      @play="emit('play')"
      @pause="emit('pause')"
      @seek="emit('seek')"
      @ended="emit('ended')"
      @timeupdate="emit('timeupdate')"
      @error="emit('error')"
    />
    <!-- <AudioElement /> -->
  </div>
</template>